import { Info24px, SWReactCountryIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Card, Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

interface IConversionRateCardHeaderProps {
    title: string;
    tooltip: string;
    dateRangeText: string;
    /**
     * When provided, the header renders two date items with `separatorText`
     * between them — used by the comparison PoP card. Omit for single-period.
     */
    compareDateRangeText?: string;
    separatorText?: string;
    countryCode: number;
    countryText: string;
    automationPrefix: string;
}

export const ConversionRateCardHeader = ({
    title,
    tooltip,
    dateRangeText,
    compareDateRangeText,
    separatorText,
    countryCode,
    countryText,
    automationPrefix,
}: IConversionRateCardHeaderProps) => (
    <Card.Header withDivider>
        <Card.Title>
            <Flex
                gap="8px"
                alignItems="center"
            >
                <Text
                    fontVariant="h5_2"
                    data-automation={`${automationPrefix}-title`}
                >
                    {title}
                </Text>
                <Tooltip
                    content={tooltip}
                    data-automation={`${automationPrefix}-title-tooltip`}
                >
                    <Info24px
                        size={24}
                        color={colorsPalettes.carbon[200]}
                        data-automation={`${automationPrefix}-title-info-icon`}
                    />
                </Tooltip>
            </Flex>
            <Card.Query>
                {compareDateRangeText ? (
                    <>
                        <Card.QueryItem iconName="daily-ranking">{compareDateRangeText}</Card.QueryItem>
                        {separatorText ? (
                            <Text
                                fontVariant="chip1"
                                color={colorsPalettes.carbon[300]}
                                data-automation={`${automationPrefix}-date-separator`}
                            >
                                {separatorText}
                            </Text>
                        ) : null}
                        <Card.QueryItem iconName="daily-ranking">{dateRangeText}</Card.QueryItem>
                    </>
                ) : (
                    <Card.QueryItem iconName="daily-ranking">{dateRangeText}</Card.QueryItem>
                )}
                <Flex
                    gap="8px"
                    alignItems="center"
                >
                    <SWReactCountryIcons
                        countryCode={countryCode}
                        size="xs"
                    />
                    <Text
                        fontVariant="chip1"
                        color={colorsPalettes.carbon[400]}
                    >
                        {countryText}
                    </Text>
                </Flex>
            </Card.Query>
        </Card.Title>
    </Card.Header>
);
